import React, { useEffect } from 'react'
import { DatePickerSeeker, disabledBefore } from '@ui-seeker/core'
import { reportFormData, useManualExecution } from 'Pages/ReportsAlerts/Reports/@signals'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { object, string } from 'yup'
import { parseBackendDate } from '@utils'
import { useComputed } from '@preact/signals-react'


export default function ReportDateMaxExecution({ useDateRange }) {

	const {
		executionDateMax,
		setExecutionDateMaxInfo,
		error,
	} = useReportFormInfo(parseBackendDate(reportFormData.peek().executionDateMax), 'executionDateMax', object({ executionDateMax: string().nullable() }))
	const executionDateMin = useComputed(() => parseBackendDate(reportFormData.value.executionDateMin))

	useEffect(() => {
		if (useManualExecution.value) setExecutionDateMaxInfo(null)
	}, [useManualExecution.value])

	useEffect(() => {
		if (!executionDateMin.value || !executionDateMax) return
		if (executionDateMin.value > executionDateMax) {
			setExecutionDateMaxInfo(executionDateMin.value)
		}
	}, [executionDateMin.value])

	if (!useDateRange) return null

	return <DatePickerSeeker
		cleanable
		disabled={useManualExecution.value}
		label="Date Max Execution"
		shouldDisableDate={disabledBefore(executionDateMin.value)}
		value={executionDateMax}
		error={error}
		onChange={e => setExecutionDateMaxInfo(e)}
	/>
}